import angular from 'angular';
const componentOptions = {
    bindings: {
    },
    controllerAs : 'giftCardsGenericErrorCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-generic-error-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-generic-error-module',
    selector: 'ibGiftCardsGenericError',
    inject: ['GiftCardsAppConstants', 'NewMainHeaderFacade', '$rootScope'],
    required: []
};
export class ibGiftCardsGenericError implements ng.IController {
    constructor ( private GiftCardsAppConstants: GiftCardsAppConstant,  private NewMainHeaderFacade: any,
        private $rootScope: CommonsRootScope) {
        this.active();
    }
    active = (): void => {
        this.NewMainHeaderFacade.initHeader(
            {
                originDestination:null,
                redemption: '',
                flightType: null,
                currency: '',
                showBasket: false
            },
            { hasSteps: false, steps: this.GiftCardsAppConstants.STEPS.STEPS, position: this.GiftCardsAppConstants.STEPS.HOME },
            {
                onLogin: function () {

                }, onError: (error: any) => {

                }, afterLogin: () => { },
                userLogged: false,
                loggedData: undefined,
                show: false
            }
        );
        this.$rootScope.fullWidth = true;
    };
}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsGenericError.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsGenericError })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsGenericError.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsGenericError })
    );
}